<template>
    
      <nav-header :showNav="true" :clearButtons="true">
      
          <template v-slot:navView>
              <h3>Reports</h3>
          </template>      
        
          <template v-slot:navLog>
              <button class="nav-btn" @click="showM()"><i :class="[showMenu ? 'fa-ellipsis-v':'fa-ellipsis-h', 'fas']"></i></button>
          </template>
      </nav-header>
  
      <div>
        Reports
      </div>
  
      <nav-menu :showMenu="showMenu" ></nav-menu>
    
  </template>
  
  <script>
//   import entiresService from "@/services/entries.js";
//   import userService from "@/services/user.js";
//   import jobsService from "@/services/jobs.js";
  import shared from "@/shared";
//   import moment from "moment";
  //import calendar from "../components/Calendar.vue";
  
  export default {
  
    name: "App",
  
   data: function () {
      return {
        loader: false,
        error: null,
        showMenu: false,        
        settDarkMode: false,
        
  
      };
    },
    
    created() {
      this.CookieCheckGoToLogin = shared.CookieCheckGoToLogin;
      this.setTheme = shared.setTheme;
      this.convertToHM = shared.convertToHM;
      this.convertToYMDHM = shared.convertToYMDHM;
      this.getDayName2 = shared.getDayName2;
      
      this.CookieCheckGoToLogin();
    },
  
    mounted() {
      this.addBodyClass('mobile');  
      
    },
  
    unmounted() {
      this.removeBodyClass('mobile');
    },
  
    methods: {

        showM() {
                this.showMenu = !this.showMenu;
        },

  
      addBodyClass(className) {
        document.body.classList.add(className);
      },
  
      removeBodyClass(className) {
        document.body.classList.remove(className);
      },
  
    }
  };
  </script>
  
  <style> 
    
  
  </style>